import Subscribers from "../../../pages/fanclub/subscriber/Subscribers";
import SubscriberEdit from "../../../pages/fanclub/subscriber/SubscriberEdit";
import {getFanclubSubscriberEditRoute, getFanclubSubscribersRoute} from "./factory/subscriber";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getFanclubSubscribersRoute(),
        component: Subscribers,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getFanclubSubscriberEditRoute(),
        component: SubscriberEdit,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;